import { ICabinetWithDimensions } from '../../models/IcabinetWithDimensions';
import { IInteriorProductSubGroup, IVec2d } from '../../models/IChainInfo';
import { IInteriorItem} from '../WebApiClient';
import { CabinetService } from './CabinetService';
import { DragServiceProps, IDragService } from './DragService';
import { DragServiceGable } from './DragServiceGable';
import { DragServiceSide } from './DragServiceSide';
import { DragServiceSnapLeftAndRight } from './DragServiceSnapLeftAndRight';
import { DragServiceTopBottom } from './DragServiceTopBottom';
import { DragServiceTopMount } from './DragServiceTopMount';

export { CabinetService, ResetTopic } from './CabinetService';
export type { ResetConfirmer, ChangeResult } from './CabinetService'
export type { IDragService, DragInfo } from './DragService';

export type { PlaceItemInfo } from './InteriorService';



export function getDragService(
    cabinet: ICabinetWithDimensions,
    cabinetService: CabinetService,
    productSubGroup: IInteriorProductSubGroup,
    item: IInteriorItem | undefined,
    cursorModelPos: IVec2d,
    mouseOffset: IVec2d,
): IDragService {
    const props: DragServiceProps = {
        cabinet,
        cabinetService,
        productSubGroup,
        item,
        cursorModelPos,
        mouseOffset
    }

    const dragServices = [
        DragServiceGable,
        DragServiceSnapLeftAndRight,
        DragServiceSide,
        DragServiceTopMount,
        DragServiceTopBottom
    ];

    for (let service of dragServices) {
        if (service.acceptable(productSubGroup)) {
            return new service(props);
        }
    }

    console.error("Could not find acceptable drag service", productSubGroup);
    throw new Error("Not implemented - Could not find acceptable drag service"); //TODO implement
}
